var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Estado de Pagos","company":_vm.comdes,"addMethod":"itemsEstadoPago","closeBaseWindow":"addEstadoPago","titleAddMethod":"Agregar Estado de Pagos","itemStoreName":"itemsEstadoPago","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Estado de Pagos',
    edicion: 'Editar Estado de Pagos',
    url: `/transjuma/EstadoPago/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }